import { render, staticRenderFns } from "./ManualReview.vue?vue&type=template&id=57905ed2&scoped=true"
import script from "./ManualReview.vue?vue&type=script&lang=js"
export * from "./ManualReview.vue?vue&type=script&lang=js"
import style0 from "./ManualReview.vue?vue&type=style&index=0&id=57905ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57905ed2",
  null
  
)

export default component.exports